import { PlanoProduto } from '@/types/produto';
import * as S from './styles';
import Text from '@/components/atoms/Text';
import formatarMoeda from '@/utils/formatarMoeda';
import { Breakpoints } from '@/hooks/useBreakpoint';
import { theme } from '@/styles/theme';

interface PlanoAssinaturaProps {
  $plano: PlanoProduto;
  $planoEstaSelecionado: boolean;
  $breakpoint: Breakpoints;
  $expansivel?: boolean;
}

export default function PlanoAssinatura(props: PlanoAssinaturaProps) {
  const {
    $plano,
    $planoEstaSelecionado,
    $breakpoint,
    $expansivel = false,
  } = props;

  return (
    <S.Container
      $breakpoint={$breakpoint}
      $selecionado={$planoEstaSelecionado}
      $expansivel={$expansivel}
    >
      <Text
        $size={2}
        $color="neutral"
        $weight="bold"
        $align="left"
        $highContrast={$expansivel && !$planoEstaSelecionado ? false : true}
        $text={$plano.nome}
        $quebraTexto={true}
      />
      <S.ContainerExpansivel
        $expansivel={$expansivel}
        $selecionado={$planoEstaSelecionado}
      >
        <Text
          $size={1}
          $color="neutral"
          $weight="regular"
          $align="left"
          $highContrast={true}
          $text={
            <ul
              style={{
                padding: `0 ${theme.spacing[4]}px`,
              }}
            >
              {$plano.maisInformacoes.map((informacao, index) => (
                <li key={index}> {informacao}</li>
              ))}
            </ul>
          }
        />
      </S.ContainerExpansivel>
      {$plano?.desconto && $plano?.desconto > 0 && (
        <Text
          style={{ textDecorationLine: 'line-through' }}
          $size={2}
          $color="neutral"
          $weight="light"
          $align="left"
          $highContrast={true}
          $text={formatarMoeda({
            valor: $plano.preco,
          })}
          $quebraTexto={false}
        />
      )}
      <Text
        $size={4}
        $color="neutral"
        $weight="bold"
        $align="left"
        $highContrast={true}
        $text={formatarMoeda({
          valor: $plano?.preco - $plano?.desconto,
        })}
        $quebraTexto={false}
      />
    </S.Container>
  );
}
